interface InputProps {
  label: string;
  name: string;
  checked: boolean;
  value: string;
  type?: string;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  clasName?: string;
}

export function Checkbox({
  label,
  name,
  checked,
  value,
  type = "checkbox",
  onChange,
  clasName,
}: InputProps) {
  return (
    <div className={`flex text-grey ${clasName}`}>
      <label className="text-md font-thin mr-2">{label}:</label>
      <input
        type={type}
        name={name}
        checked={checked}
        value={value}
        onChange={onChange}
        className={`p-2 cursor-pointer accent-blue-500`}
      />
    </div>
  );
}
